<template>
  <div>
    <v-menu
      ref="menu"
      v-model="show"
      :close-on-content-click="false"
      max-width="290"
      offset-y
    >
      <template #activator="{ on, attrs }">
        <v-text-field
          v-model="fieldDate"
          :label="label"
          :error="isInvalidDate"
          placeholder="DD/MM/YYYY"
          filled
          hide-details
          append-icon="event"
          autocomplete="off"
          v-bind="attrs"
          v-on="on"
          @click:append="show = true"
          @keyup.enter="show = false"
          @input="saveDate($event)"
        />
      </template>
      <v-date-picker
        v-model="pickerValue"
        no-title
        @change="savePickerValue($event)"
      />
    </v-menu>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    value: { type: Date, default: null },
    label: { type: String, default: null }
  },
  data() {
    return {
      show: false,
      pickerValue: '',
      fieldDate: '',
      isInvalidDate: false
    }
  },
  methods: {
    saveDate(date) {
      const momentDate = moment(date, 'DD/MM/YYYY', true)
      if (momentDate.isValid()) {
        const convertedDate = momentDate.format('YYYY-MM-DD')
        this.pickerValue = convertedDate
        this.isInvalidDate = false
        this.$emit('input', new Date(convertedDate))
      } else {
        this.isInvalidDate = true
      }
    },
    savePickerValue(date) {
      this.$refs.menu.save(date)
      this.fieldDate = moment(date).format('DD/MM/YYYY')
      this.saveDate(this.fieldDate)
    }
  }
}
</script>
